import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, Card, CardContent, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import MDEditor from '@uiw/react-md-editor';
import { Report } from '../types/report.ts';
import { formatDate } from '../utils/helpers.ts';

const ReportDetail = () => {
   const { id } = useParams<{ id: string }>();
   const [report, setReport] = useState<Report | null>(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState('');

   useEffect(() => {
      axios.get(`https://backend.schnee.report/api/reports?filters[documentId][$eq]=${id}&status=draft&populate=*`)
         .then(res => setReport(res.data.data[0]))
         .catch(() => setError('Fehler beim Laden des Reports'))
         .finally(() => setLoading(false));
   }, [id]);

   if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh"><CircularProgress /></Box>;
   if (error) return <Alert severity="error">{error}</Alert>;
   if (!report) return <Alert severity="warning">Report nicht gefunden.</Alert>;
   console.log(report);

   return (
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
         <Card>
            <CardContent>
               <Typography variant="h4" gutterBottom>{report.title}</Typography>
               <Typography variant="h6" color="text.secondary">Gültig ab: {formatDate(report.valid_from)}</Typography>
               <Typography variant="h6" color="text.secondary">Gültig bis: {report.valid_until?formatDate(report.valid_until):"-"}</Typography>
               <br></br>
               <div style={{ marginTop: "10px" }} className="p-4 border rounded bg-gray-50">
                  <MDEditor.Markdown source={report.content} />
               </div>
               <br></br>
               <Typography variant="h6" color="text.secondary">Erstellt: {formatDate(report.createdAt)}</Typography>
               <Typography variant="h6" color="text.secondary">Zuletzt aktualisiert: {formatDate(report.updatedAt)}</Typography>
            </CardContent>
         </Card>
      </Container>
   );
};

export default ReportDetail;
